import React from 'react';
import styles from './SwapCalculator.module.scss';

interface BuyLinkProps {
  href: string;
  onClick: () => void;
  tokenSymbol: string;
}

const BuyLink: React.FC<BuyLinkProps> = ({ href, onClick, tokenSymbol }) => (
  <a
    className={styles.swapCalcBuyBtn}
    href={href}
    target="_blank"
    rel="noopener noreferrer nofollow"
    onClick={onClick}
  >
    Swap {tokenSymbol}
  </a>
);

export default BuyLink; 